export const HELP_BUTTON_WIDTH = 16;
export const OUTLINE_WIDTH = "1px";
export const TILE_IMAGE_SIZE = "24px";
export const TILE_ROW_MOBILE_MARGIN = "-24px";
